<div *ngIf="this.allowanceEntity.toeslagen?.geboortedatumAanvrager === undefined">
    <snelstart-ui-alert type="info">
        Start een aanvraag Toeslagen <u>altijd</u> met het invullen van de persoonlijke, inkomens- en vermogensgegevens
        van
        de aanvrager.<br/>
        Dit doe je bij onderdeel 1. Gegevens & zorgtoeslag. Vul daarna de aanvraag verder in voorzover van
        toepassing.
    </snelstart-ui-alert>
</div>

<div *ngIf="this.allowanceEntity.toeslagen?.geboortedatumAanvrager !== undefined">
    <form [formGroup]="kindFg">
        <div formArrayName="kinderen">
            <div *ngFor="let item of kinderen.controls; let i = index" [formGroupName]="i">
                <div class="row mb-0.5">
                    <div class="col-auto">
                        <snelstart-ui-text-form-control (change)="saveForm()"
                                                        [label]="i === 0 ? 'Roepnaam' : ''"
                                                        [required]=true
                                                        class="custom-input-150"
                                                        formControlName="voornaam"
                                                        id="voornaam"
                        >
                        </snelstart-ui-text-form-control>
                    </div>
                    <div class="col-auto">
                        <snelstart-ui-date-form-control (change)="saveForm()"
                                                        [label]="i === 0 ? 'Geboortedatum' : ''"
                                                        [required]=true
                                                        class="custom-input-150"
                                                        formControlName="geboortedatum"
                                                        id="geboortedatum"
                                                        placeholder="dd-mm-jjjj"
                        >
                        </snelstart-ui-date-form-control>
                    </div>
                    <div class="col-auto">
                        <snelstart-ui-bsn-form-control (change)="saveForm()"
                                                       [label]="i === 0 ? 'Burgerservicenummer' : ''"
                                                       [required]=true
                                                       class="custom-input-150"
                                                       formControlName="bsn"
                                                       id="bsn"
                        >
                        </snelstart-ui-bsn-form-control>
                    </div>
                    <div class="col-auto">

                        <snelstart-ui-select-form-control (change)="saveForm()"
                                                          [label]="i === 0 ? 'Ingeschreven bij aanvrager' : ''"
                                                          [options]="itemsInschrijvingAangever"
                                                          [required]=true
                                                          class="custom-input-250"
                                                          formControlName="ouderOntvangtKinderbijslag"
                                                          id="ouderOntvangtKinderbijslag-{{i}}"
                        >
                        </snelstart-ui-select-form-control>
                    </div>
                    <div class="col-auto">
                        <div *ngIf="kinderen.controls[i].get('ouderOntvangtKinderbijslag')?.value === false">
                            <snelstart-ui-select-form-control
                                    (change)="saveForm()"
                                    [label]="i === 0 ? 'Co-ouderschap' : ''"
                                    [options]="optionsJaNee"
                                    [required]=true
                                    [disabledControl]="false"
                                    class="custom-input-250"
                                    formControlName="onderhoudBelangrijkeMate"
                                    id="ouderOntvangtKinderbijslag-{{i}}"
                            >
                            </snelstart-ui-select-form-control>
                        </div>
                        <div *ngIf="kinderen.controls[i].get('ouderOntvangtKinderbijslag')?.value === true">
                            <snelstart-ui-select-form-control
                                    (change)="saveForm()"
                                    [disabledControl]="true"
                                    [label]="i === 0 ? 'Co-ouderschap' : ''"
                                    [options]="optionsNvt"
                                    class="custom-input-250"
                                    formControlName="onderhoudBelangrijkeMate"
                                    id="ouderOntvangtKinderbijslag-{{i}}"
                            >
                            </snelstart-ui-select-form-control>
                        </div>
                    </div>
                    <div class="col-auto">
                        <snelstart-ui-button (click)="verwijderRij(i)"
                                             [class]="i === 0 ? 'firstrowbutton' : ''"
                                             icon="trash"
                                             iconType="light"
                                             id="buttonDelete"
                                             size="medium"
                                             type="secondary"
                        >
                        </snelstart-ui-button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="kinderen.length === 0 && allowanceEntity && allowanceEntity.year">
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelA"
                         type="link">Gegevens kind geboren
        na {{ (allowanceEntity.year) - 19 }} invullen
    </snelstart-ui-button>
</div>
<div *ngIf="kinderen.length !== 0">
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelB"
                         type="link">Kind toevoegen
    </snelstart-ui-button>
</div>
